export default "__VITE_ASSET__K6s49953__"